import { v4 as uuidv4 } from 'uuid';

export const onLoadBiocatch = () => () => {
  const uuid = uuidv4().replace(/-/g, '');
  if (window.cdApi) {
    window.cdApi.setCustomerSessionId(uuid);
    window.sessionStorage.setItem('biocatch_visitor_tracking', uuid);
  }
};
